var $ = require('jquery');
(function ($) {
    if (document.querySelectorAll('input[name="__RequestVerificationToken"]').length != 0) {
      $.ajax({
            url: window.location.origin + "/api/sitecore/GetAntiForgeryToken/Index",
            type: 'GET',
            dataType: 'json', // added data type
            success: function (res) {
                $('input[name="__RequestVerificationToken"]').val(res.formToken);
            },
        });
    }
}($));
